<mat-form-field
  [ngStyle]="{ width: width }"
  color="{{ color }}"
  appearance="{{ appearance }}"
>
  <mat-label
    >{{ placeholder }}
    <span
      *ngIf="required && placeholder !== null"
      style="color:#ef5350; font-weight: bold"
      >*</span
    >
  </mat-label>
  <input
    id="{{ id }}"
    matInput
    #autoCompleteInputField
    placeholder="{{ placeholder }}"
    [matAutocomplete]="auto"
    [(ngModel)]="model"
    [formControl]="control"
    (input)="search($event)"
    (blur)="onInputAutoCompleteBlur($event)"
    (click)="onInputAutoCompleteClick($event)"
  />
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error>{{ error }}</mat-error>
</mat-form-field>
<div *ngIf="!priorOptionSelected">
  <mat-autocomplete #auto="matAutocomplete" >
    <mat-option
      id="o{{suggestion.id}}"
      *ngFor="let suggestion of suggestions"
      [value]="suggestion[fieldToDisplay]"
      (onSelectionChange)="onSelect(suggestion)"
      [ngClass]="{
      'highlight-option': suggestion.highlight,
      'sub-option': !suggestion.highlight && ordered
    }"
      [disabled]="suggestion.disabled"
    >
      {{ suggestion[fieldToDisplay] }}
    </mat-option>
  </mat-autocomplete>
</div>

<div *ngIf="priorOptionSelected">
  <mat-autocomplete  #auto="matAutocomplete"  *ngIf="priorOptionSelected"
                     (optionSelected)="optionSelectedValue($event.option.value)">
    <mat-option
      id="o{{suggestion.id}}"
      *ngFor="let suggestion of suggestions"
      [value]="suggestion"
      (onSelectionChange)="onSelect(suggestion)"
      [ngClass]="{
      'highlight-option': suggestion.highlight,
      'sub-option': !suggestion.highlight && ordered
    }"
      [disabled]="suggestion.disabled"
    >
      {{ suggestion[fieldToDisplay] }}
    </mat-option>
  </mat-autocomplete>
</div>

